var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SurveyForm',{attrs:{"config":_vm.formattedAttestationConfig},on:{"onSubmit":_vm.handleSubmit}}),_c('div',{staticClass:"text-center"},[(!!_vm.error)?_c('FormError',{attrs:{"text":_vm.error}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }